import type { DirectiveConfig } from '../../content/directiveParser'

/**
 * Small helpers for reading and validating directive configuration at the
 * component boundary. Keep validation here so each interaction can fail over to
 * a static fallback on invalid config instead of throwing.
 */

export function getString(config: DirectiveConfig, key: string): string | undefined {
  const value = config[key]
  return typeof value === 'string' ? value : undefined
}

export function getNonEmptyString(config: DirectiveConfig, key: string): string | undefined {
  const value = getString(config, key)
  return value && value.trim() !== '' ? value : undefined
}

/**
 * Read a scalar as a string, coercing numbers/booleans. Use for values that are
 * conceptually text but may be parsed as another scalar type — e.g. an `answer`
 * of `2` that the config parser coerced to a number.
 */
export function getScalarString(config: DirectiveConfig, key: string): string | undefined {
  const value = config[key]
  if (typeof value === 'string') return value.trim() !== '' ? value : undefined
  if (typeof value === 'number' || typeof value === 'boolean') return String(value)
  return undefined
}

export function getStringList(config: DirectiveConfig, key: string): string[] | undefined {
  const value = config[key]
  if (!Array.isArray(value)) return undefined
  const items = value.filter((item) => typeof item === 'string' && item.trim() !== '')
  return items.length > 0 ? items : undefined
}
